import { render, staticRenderFns } from "./FolderEditModalComp.vue?vue&type=template&id=6aa42d7e&scoped=true"
import script from "./FolderEditModalComp.vue?vue&type=script&lang=js"
export * from "./FolderEditModalComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa42d7e",
  null
  
)

export default component.exports